import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetProductDetailById } from "../Services/MainServices";

export const useProductDetails = () => {
  const { pro_id } = useParams();
  const [productDetails, setProductDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async (id) => {
    setLoading(true);
    try {
      const res = await GetProductDetailById(id);

      setProductDetails(res.data);
    } catch (err) {
      setError(err.message ?? "Failed to get product details");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData(pro_id);
  }, [fetchData]);

  return { productDetails, loading, error, refetch: fetchData };
};
